import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ValidValueHelper  {
    _originalTypeClassName = "zERP.BO.ValidValueHelper";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ValidValueHelper.translate = translateService;
}
this.ValidValueHelperKey = null;
this._key = this.ValidValueHelperKey = 0; 
}

static translate: TranslateService;
_key: any;
private _ValidValueHelperKey:any;
get ValidValueHelperKey(): any {
    return this._ValidValueHelperKey;
  }
set ValidValueHelperKey(value: any) {
    this._ValidValueHelperKey = value;
    this._key = value;
  }

static isDateTime(value: any): any{try {moment(value).toDate();return true;}
catch (e) {return false;}
}
static isNumber(value: any): any{try {CLMS.Framework.Double.Parse(value);return true;}
catch (e) {return false;}
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.ValidValueHelperKey == null || $this.ValidValueHelperKey == 0;
            }


}